import { Component } from "@angular/core";

@Component({
    selector: "ifc-broker-api-key-card",
    templateUrl: "./broker-api-key-card.component.html",
    styleUrls: ["./broker-api-key-card.component.scss"],
    standalone: false
})
export class BrokerApiKeyCardComponent {}
